import WordPasswords from './WordPasswords';
export default WordPasswords;
